import React , { useCallback,useEffect,useState,useContext } from 'react';
import { Table,Spin,Input,Modal,Button,message,Select,InputNumber,Popover} from 'antd';

import _ from "lodash";
import { APIrequest } from '../../Helpers.js'
import { parseRules } from '../Projections/Scoring'
import { UserContext } from "../../Contexts/UserContext";
// import { useReactToPrint } from 'react-to-print';
function MyDash (props) {
    const { userID } =
    useContext(UserContext);
    const { Option } = Select;
    const [posSearch, setPosSearch] = useState('QB');
    const [myTradePlayers, setMyTradePlayers] = useState([]);
    const [myTeam, setMyTeam] = useState([]);
    const [myTeamName, setMyTeamName] = useState(null);
    const [tradeTeam, setTradeTeam] = useState([]);
    const [theirTradePlayers, setTheirTradePlayers] = useState([]);
    const [isTradeModalOpen, setIsTradeModalOpen] = useState(false);
    const [depthSearch, setDepthSearch] = useState(2);
    const [statSearch, setStatSearch] = useState('PPG');
    const [teams, setTeams] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [projections, setProjections] = useState([]);
    const [values, setValues] = useState([]);
    const [projectionsLoading, setProjectionsLoading] = useState(false);
    const [team, setTeam] = useState(null);
    const [PFFdata, setPFFdata] = useState([]);
    const [PFFteamData, setPFFteamData] = useState([]);
    const [myLeagues, setMyLeagues] = useState([]);
    const [RBmultiplier, setRBmultiplier] = useState(1);
    const [TEmultiplier, setTEmultiplier] = useState(2);
    const [WRmultiplier, setWRmultiplier] = useState(1);
    const [QBmultiplier, setQBmultiplier] = useState(1.3);
    const [scoringLoading, setScoringLoading] = useState(false);
    const [curatedAssets, setCuratedAssets] = useState([]);
    const [league, setLeague] = useState(null);
    const [assets, setAssets] = useState([]);

    const [sorter, setSorter] = useState("value");
    const [scoring, setScoring] = useState({"QB":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"RB":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"WR":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"TE":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0}});
    const calcPoints=(data)=>{
      const receptionPts= data.Position==='WR'?1.25:(data.Position==='TE'?1.75:1)
      const PointsPer10= (data.Position==='TE'?1.5:1)
      return (Math.round((
          data.Yards*scoring[data.Position]["Passing Yards"]+
          data.PassingTouchdowns*scoring[data.Position]["Number of Passing TDs"]+
          data.Interceptions*scoring[data.Position]["Pass Interceptions Thrown"]+
          data.Receptions*scoring[data.Position]["Receptions"]+
          data.ReceivingYards*scoring[data.Position]["Receiving Yards"]+
          data.ReceivingTouchdowns*scoring[data.Position]["Number of Receiving TDs"]+
          data.RushingTDs*scoring[data.Position]["Number of Rushing TDs"]+
          data.RushingYards*scoring[data.Position]["Rushing Yards"])*100)/100)
  }
    
    const getProjections = async ()=>{
        setProjectionsLoading(true)
        console.log("Fetching Projections")
        fetch(`/api/db/getProjections/${userID}/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data=> calcScores(data.response,1))
        .then(data => {setProjections(data);setProjectionsLoading(false)
        });
      }
      const getTeamData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getTeamPlays/${userID}/2022`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setTeamData(data.response);
        });
      }
      const getPFFData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getPFF/${userID}/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setPFFdata(data.response);
        });
      }
      const getMyLeagues = async ()=>{
        console.log("Fetching Leagues")
        const result=await APIrequest(`/api/mfl/myLeagues`)
        .then(data => {console.log(data);setMyLeagues(data.leagues.league);setLeague(data.leagues.league[0]["league_id"]);setMyTeamName(data.leagues.league[0]["franchise_name"]);
        });
      }
      const getAssets = async ()=>{
        console.log("Fetching Leagues")
        if (league>0){
        const result=await APIrequest(`/api/mfl/assets/${league}`)
        .then(data => {console.log(data);setAssets(data)})
      return result}
      }   
      const getValues = async ()=>{
        console.log("Fetching values")
        
        const result=await APIrequest(`/api/db/values`)
        .then(data => {console.log(data);setValues(data)})
      return result
      }  
      const getLeagueRules = async ()=>{
        if (league)
        {
        setScoringLoading(true)
        console.log("Fetching Leagues")
        await APIrequest(`/api/mfl/getLeagueRules?L=${league}`)
        .then(data => {console.log(data.rules.positionRules);setScoring(parseRules(data.rules.positionRules));setScoringLoading(false);
        });}
      }

      const addPPG  = async (p) =>{
        return({...p,PPG:await calcPoints(p)})
      }

      const calcScores = async (proj=false,ret=0) =>{
        var temp = proj?[...proj]:[...projections]
        temp=await Promise.all(temp.map(async (p)=>await addPPG(p)))
        if (ret===1){
          console.log("temp",await temp)
          return await  temp
        }
        else{
          setProjections(await temp)
        }
        
      }

      useEffect(()=> {
        compileAssets();
      } ,[assets,QBmultiplier,RBmultiplier,TEmultiplier,WRmultiplier,scoring,values]);

      useEffect(()=> {
        if (curatedAssets.length>0 && myTeamName)
        {
        setMyTeam(curatedAssets.find(t=>t.name===myTeamName)?.players.sort((a,b)=> b.value-a.value));
        }
      } ,[curatedAssets]);
      
    useEffect(()=> {
        getMyLeagues();
        getValues();
    } ,[]);

    useEffect(()=> {
        getProjections();
    } ,[]);

    useEffect(()=> {
      getAssets()
      getLeagueRules()
    } ,[league]);

    useEffect(()=> {
      calcScores();
    } ,[scoring]);

    useEffect(()=> {
  } ,[league]);
      
   
  
  const onLeagueChange= e => {
    setLeague(e);
    setMyTeamName(myLeagues.find(l=>l.league_id===e)['franchise_name'])
};

const onTradeTeamChange= e => {
  setTradeTeam(curatedAssets.find(l=>l.name===e)['players'].sort((a,b)=>b.value-a.value));
};

const OptimizedLineup= (players) => {
  var lineup=[]
  
  lineup=lineup.concat(players.filter(p=>p.pos==='QB' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,1))
  lineup=lineup.concat(players.filter(p=>p.pos==='RB' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,2)) 
  lineup=lineup.concat(players.filter(p=>p.pos==='WR' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,3))
  lineup=lineup.concat(players.filter(p=>p.pos==='TE' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,2))
  lineup=lineup.concat(players.filter(p=>!lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,1))
  lineup=lineup.concat(players.filter(p=>p.pos!=='QB' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,2))
  return lineup
};

const forceArray =(obj)=>{
  if (Array.isArray(obj))
  {
    return obj
  }
  else{
    return [obj]
  }
}

const compileAssets=()=>{
  setCuratedAssets(assets.map(franchise=>{return({
    name:franchise.name,
  Picks:{"1st":(forceArray(franchise.futureYearDraftPicks?.draftPick||[])).filter(p=>p.description.includes('Round 1')).length,
  "2nd":(forceArray(franchise.futureYearDraftPicks?.draftPick||[])).filter(p=>p.description.includes('Round 2')).length,
  "3rd":(forceArray(franchise.futureYearDraftPicks?.draftPick||[])).filter(p=>p.description.includes('Round 3')).length
},
Pickvalue:(forceArray(franchise.futureYearDraftPicks?.draftPick||[])).filter(p=>p.description.includes('Round 1')).length*1*values.find(v=>v.player==="2023 Mid 1st")?.KTCvalue+
(forceArray(franchise.futureYearDraftPicks?.draftPick||[])).filter(p=>p.description.includes('Round 2')).length*1*values.find(v=>v.player==="2023 Mid 2nd")?.KTCvalue+
(forceArray(franchise.futureYearDraftPicks?.draftPick||[])).filter(p=>p.description.includes('Round 3')).length*1*values.find(v=>v.player==="2023 Mid 3rd")?.KTCvalue,
  value:franchise?.players?.player.map(p=>adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.adjustedValue||0).reduce((partialSum, a) => partialSum + a||0, 0),
  AgeFactor:franchise?.players?.player.map(p=>adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.AgeFactor*adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.adjustedValue||0).reduce((partialSum, a) => partialSum + a||0, 0)/ 
  franchise?.players?.player.map(p=>adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.adjustedValue||0).reduce((partialSum, a) => partialSum + a||0, 0),
   players:franchise?.players?.player.map(
     p=>{
       const {adjustedValue,PlayerName,Position,MFL_ID,AgeFactor}=adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))||{}; 
       return({player:PlayerName,pos:Position,value:adjustedValue,MFL_ID:MFL_ID,PPG:(projections.find(proj=>proj.MFL_ID===parseInt(p.id))||{"PPG":0})["PPG"],AgeFactor:AgeFactor})})

})
}))
}


  const adjustedValues=() => {
    var temp=values.map(p=>{return({...p,adjustedValue:(p.Position==='TE'?p.KTCvalue*TEmultiplier:(p.Position  ==='QB'?p.KTCvalue*QBmultiplier:p.KTCvalue))})})

  
    return temp
}


    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    

    const leagueCols=[ 
      {
      title: 'Team',
      dataIndex: 'name',
      key: 'name',
      width:100,
      sorter: (a,b) => a.name-b.name,
      render: (text, record) => {
        return (
          <div>{record.name}</div>)}
    },
    {
      title: 'KTC Value',
      dataIndex: 'value',
      key: 'value',
      width:100,
      sorter: (a,b) => a.value-b.value,
      render: (text, record) => {
        return (
          <Popover
          placement="bottom"
          content={
              <div>
            {record?.players.sort((a,b)=>b.value-a.value).map(x=><div>{x.player} {x.pos}: {Math.round(x.value)}</div>)}
            </div>
            
          }
        >
          <div>{Math.round(record.value)}</div>
          </Popover>
          )}
    },
    {
      title: 'Projection',
      dataIndex: 'PPG',
      key: 'PPG',
      width:100,
      sorter: (a,b) => OptimizedLineup(a?.players).reduce((partialSum, x) => partialSum + x.PPG||0, 0)-OptimizedLineup(b?.players).reduce((partialSum, x) => partialSum + x.PPG||0, 0),
      render: (text, record) => {
        return (
          <Popover
          placement="bottom"
          content={
              <div>
            {OptimizedLineup(record.players).sort((a,b)=>b.value-a.value).map(x=><div>{x.player} {x.pos}: {x.PPG }</div>)}
            </div>
          }
        >
          <div>{Math.round(OptimizedLineup(record?.players).reduce((partialSum, x) => partialSum + x.PPG||0, 0))}</div>
          </Popover>)}
    },
    {
      title: 'Age Factor',
      dataIndex: 'age',
      key: 'age',
      width:100,
      sorter: (a,b) => a.AgeFactor-b.AgeFactor,
      render: (text, record) => {
        return (
          <Popover
          placement="bottom"
          content={
            <div className='flexrow'>
              <div>
            {record?.players.sort((a,b)=>b.AgeFactor-a.AgeFactor).map(x=><div>{x.player} {x.pos}: {Math.round(x.AgeFactor)}</div>)}
            </div>
            </div>
          }
        >
          <div>{record.AgeFactor}</div>
          </Popover>)}
    },
    {
      title: 'Picks',
      dataIndex: 'Picks',
      key: 'Picks',
      width:100,
      sorter: (a,b) => a.Picks-b.Picks,
      render: (text, record) => {
        return (
         
          <div>{JSON.stringify(record.Picks)}</div>
         )}
    },
    {
      title: 'Pick Value',
      dataIndex: 'Pickvalue',
      key: 'Pickvalue',
      width:100,
      sorter: (a,b) => a.Pickvalue-b.Pickvalue,
      render: (text, record) => {
        return (
          
          <div>{Math.round(record.Pickvalue)}</div>
          )}
    },
    {
      title: 'Total Value',
      dataIndex: 'totvalue',
      key: 'totvalue',
      width:100,
      sorter: (a,b) => ((a.Pickvalue||0)+a.value)-((b.Pickvalue||0)+b.value),
      render: (text, record) => {
        return (
          
          <div>{Math.round(record.Pickvalue+record.value)}</div>
          )}
    },
    {
      title: 'QB2',
      dataIndex: 'QB2',
      key: 'QB2',
      width:100,
      sorter: (a,b) => {
        const x=(a?.players.filter(p=>p.pos===posSearch).sort((aa,ab)=>ab[statSearch]-aa[statSearch]).slice(depthSearch-1,depthSearch)[0]||{})[statSearch]
        const y=(b?.players.filter(p=>p.pos===posSearch).sort((aa,ab)=>ab[statSearch]-aa[statSearch]).slice(depthSearch-1,depthSearch)[0]||{})[statSearch]
        return (
          
          y-x
          )},
      render: (text, record) => {
        const x=(record?.players.filter(p=>p.pos===posSearch).sort((a,b)=>b[statSearch]-a[statSearch]  ).slice(depthSearch-1,depthSearch)[0]||{})[statSearch]
        return (
          
          <div>{Math.round(x)}</div>
          )}
    }
  ]
  console.log(curatedAssets)
  console.log(myLeagues)
  console.log(myTeamName)
  console.log(myTeam)

    return (
        <div>
          <Button onClick={()=>setIsTradeModalOpen(true)}>Trade Calc</Button>
          <Modal width='2000px' visible={isTradeModalOpen} onOk={()=>setIsTradeModalOpen(false)} onCancel={()=>setIsTradeModalOpen(false)}>
          <Select
            size='small'
              mode="single"
              optionLabelProp="label"
              allowClear={false}
              style={{ width: '300px' }}
              value={tradeTeam}
              onChange={(e)=>onTradeTeamChange(e)}
              optionLabelProp="label"
            >
              {curatedAssets.map(b=>
              <Option value={b.name} label={b.name}>
                  <div>{b.name}</div>
              </Option>)}
        </Select>
        <div className='flexrow'>
          <div className='flexcol'>
            <Select
              size='small'
                mode="multiple"
                optionLabelProp="label"
                allowClear={false}
                style={{ width: '300px' }}
                value={myTradePlayers}
                onChange={(e)=>setMyTradePlayers(e)}
                optionLabelProp="label"
              >
                {myTeam.map(b=>
                <Option value={b.player} label={b.player}>
                    <div>{b.player}, {b.value}, {b.pos}</div>
                </Option>)}
            </Select>
            {myTeam.filter(p=>myTradePlayers.includes(p.player)).map(
              p=><div>{p.player},{p.value},{p.AgeFactor}</div>
            )}
            <div>{myTeam.filter(p=>myTradePlayers.includes(p.player)).reduce((partialSum, x) => partialSum + x.value,0)}</div>
          </div>
          <div className='flexcol'><Select
              size='small'
                mode="multiple"
                optionLabelProp="label"
                allowClear={false}
                style={{ width: '300px' }}
                value={theirTradePlayers}
                onChange={(e)=>setTheirTradePlayers(e)}
                optionLabelProp="label"
              >
                {tradeTeam.map(b=>
                <Option value={b.player} label={b.player}>
                    <div>{b.player}, {b.value}, {b.pos}</div>
                </Option>)}
            </Select>
            {tradeTeam.filter(p=>theirTradePlayers.includes(p.player)).map(
              p=><div>{p.player},{p.value},{p.AgeFactor}</div>
            )}
            <div>{tradeTeam.filter(p=>theirTradePlayers.includes(p.player)).reduce((partialSum, x) => partialSum + x.value,0)}</div>
            </div>
        </div>
          
          </Modal>
            <div className='flexrow'>
        Select League:  
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={league}
          onChange={(e)=>onLeagueChange(e)}
          optionLabelProp="label"
        >
          {myLeagues.map(b=>
          <Option value={b.league_id} label={b.name}>
              <div>{b.name}</div>
          </Option>)}
        </Select>
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={posSearch}
          onChange={(e)=>setPosSearch(e)}
          optionLabelProp="label"
        >
          {['','QB','WR','RB','TE'].map(b=>
          <Option value={b} label={b}>
              <div>{b}</div>
          </Option>)}
        </Select>
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={depthSearch}
          onChange={(e)=>setDepthSearch(e)}
          optionLabelProp="label"
        >
          {[1,2,3,4,5,6].map(b=>
          <Option value={b} label={b}>
              <div>{b}</div>
          </Option>)}
        </Select>
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={statSearch}
          onChange={(e)=>setStatSearch(e)}
          optionLabelProp="label"
        >
          {['PPG','value'].map(b=>
          <Option value={b} label={b}>
              <div>{b}</div>
          </Option>)}
        </Select>
        </div>
        {/* {JSON.stringify(assets)} */}
       
        <Table dataSource={curatedAssets}
        columns={leagueCols}
        scroll={{ x: 800, y:  'max-content' }} />
        
      
      
        
        </div>
        
        )
        
    }

    export default MyDash;


